import { useDispatch } from 'react-redux'
import { useAppSelector } from 'universal-scripts'
import { toggleSidebar } from 'src/store/slices/ui'

import './MenuButton.css'

export default function MenuButton() {
  const dispatch = useDispatch()

  const isOpen = useAppSelector((state) => state.ui.isSidebarOpen)

  const handleClick = () => {
    dispatch(toggleSidebar())
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={isOpen}
      className={`menu-button icon icon-menu only-responsive`}
    />
  )
}
